import { usePerformanceReport } from './performance-report.mjs';

function PerformanceReport({
  url,
  onError,
  locale
}) {
  usePerformanceReport(url, {
    onError,
    locale
  });
  return null;
}

export { PerformanceReport };
